import { FC, useState } from "react";
import { Button } from "@altimateai/lego";
import { IconCalendar } from "@tabler/icons-react";
import { useAppState } from "@/modules/app/useAppContext";
import ScheduleDialog from "./ScheduleDialog";

interface PlaygroundScheduleActionProps {
  sessionId?: string;
  sessionName: string;
}

const PlaygroundScheduleAction: FC<PlaygroundScheduleActionProps> = ({
  sessionId,
  sessionName,
}) => {
  const { enableStudioScheduledReports } = useAppState();
  const [scheduleDialogOpen, setScheduleDialogOpen] = useState(false);

  if (!enableStudioScheduledReports || !sessionId) return null;

  return (
    <>
      <Button
        variant="outline"
        size="sm"
        className="al-bg-transparent al-text-gray-500"
        aria-label="Schedule report"
        onClick={() => setScheduleDialogOpen(true)}
      >
        <IconCalendar aria-hidden="true" />
        Schedule
      </Button>
      <ScheduleDialog
        sessionId={sessionId}
        sessionName={sessionName}
        open={scheduleDialogOpen}
        onOpenChange={setScheduleDialogOpen}
      />
    </>
  );
};

export default PlaygroundScheduleAction;
